// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-up-right.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-up-right',
  version: 'outline',
  paths: [
    {
      d: 'm4.5 19.5 15-15m0 0H8.25m11.25 0v11.25',
    },
  ],
}
